<div class="error-wrapper modal-main-wrapper">
    <div class="close-container">
        <div class="img-container">
            <img src="../../../assets/icons/Close.svg" (click)="close()">
        </div>        
    </div>
    <div class="content-wrapper">
        <img *ngIf="data.icon;else defaultIcon" [src]="data.icon" alt="error" class="icon" />
        <ng-template #defaultIcon>
            <img  src="../../../assets/icons/icon-warning.svg" alt="error" class="icon" />
        </ng-template>
        <div class="message">{{data.message}}</div>
        <div class="description">{{data.description}}</div>
    </div>
    <footer>
        <div class="button-wrapper">
            <button class="action-btn white-text" (click)="close()">OK</button>
        </div>
    </footer>
</div>